import { ActionType } from '../constants/ActionTypes'

export default function messagesReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.GET_CLIENT_MESSAGES_BEGIN:
            return {
                ...state,
                isLoading: true,
                data: {
                    count: 0,
                    messages: []
                }
            }
        case ActionType.GET_CLIENT_MESSAGES_AND_KEEP_OLD_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case ActionType.GET_CLIENT_MESSAGES_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
                data: {
                    count: 0,
                    messages: []
                }
            }
        case ActionType.GET_CLIENT_MESSAGES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload
            }
        case ActionType.GET_CLIENT_MESSAGES_AND_KEEP_OLD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: {
                    ...state.data,
                    messages: [
                        ...state.data.messages,
                        ...(action.payload.messages || [])
                    ]
                }
            }
        case ActionType.MARK_IDS_READ:
            return {
                ...state,
                // data: {
                //     ...state.data,
                //     messages: state.data.messages.map(item => {
                //         if(action.payload.indexOf(item.id) >= 0) {
                //             return {
                //                 ...item,
                //                 state: 3
                //             }
                //         }
                //         return item
                //     })
                // }
            }
        case ActionType.READ_MESSAGE:
            let isMsgUnread = false;
            const messages = state.data.messages.map(item => {
                if (item.id === action.payload && item.state === 1) {
                    isMsgUnread =true;
                    return {
                        ...item,
                        state: 3
                    }
                }
                return item;
            });

            return {
                ...state,
                unreadCount: isMsgUnread && state.unreadCount > 0 ? state.unreadCount - 1 : state.unreadCount, 
                data: {
                    ...state.data,
                    messages
                }
            }
        case ActionType.GET_CLIENT_UNREAD_MESSAGES_COUNT_BEGIN:
            // let messages = state.data.messages.map(message => {
            //     return action.payload.some(i => i === message.id)  ? { ...message, state: 2 } : message
            // })
            return {
                ...state,
                data: {
                    ...state.data,
                    // messages: messages
                }
            }
        case ActionType.GET_CLIENT_UNREAD_MESSAGES_COUNT_ERROR:
        case ActionType.READ_CLIENT_MESSAGE_ERROR:
            return {
                ...state,
                error: action.payload
            }
        case ActionType.GET_CLIENT_UNREAD_MESSAGES_COUNT_SUCCESS:
            return {
                ...state,
                unreadCount: action.payload
            }
        case ActionType.READ_CLIENT_MESSAGE_BEGIN:
            return {
                ...state
            }
        case ActionType.READ_CLIENT_MESSAGE_SUCCESS:
            const readfilteredMessages = action.payload.allMessages ? action.payload.id.length ? state.data.messages.map(item => {
                if (action.payload.id.indexOf(item.id) < 0) {
                    return {
                        ...item,
                        state: 2
                    }
                }
                return item
            }) : state.data.messages.map(item => {
                return {
                    ...item,
                    state: 2
                }
            }) : state.data.messages.map(item => {
                if (action.payload.id.indexOf(item.id) >= 0) {
                    return {
                        ...item,
                        state: 2
                    }
                }
                return item
            })
            return {
                ...state,
                data: {
                    ...state.data,
                    messages: readfilteredMessages
                }

            }
        case ActionType.SAVE_MESSAGE_BEGIN:
        case ActionType.DELETE_MESSAGE_BEGIN:
            return {
                ...state,
                inProcess: true
            }
        case ActionType.SAVE_MESSAGE_SUCCESS:
            let newMessages;
            if (action.payload.parentId) {
                newMessages = state.data.messages.map((msg) => {

                    if (msg.id == action.payload.parentId) {
                        if (msg.nestedMessages) {
                            msg.nestedMessages = [...msg.nestedMessages, action.payload]
                        } else {
                            msg.nestedMessages = [action.payload]
                        }
                    }
                    return msg;
                });
            } else {
                newMessages = [action.payload, ...(state.data.messages || [])]
            }

            return {
                ...state,
                data: {
                    ...state.data,
                    messages: newMessages
                },
                inProcess: false
            }
        case ActionType.SAVE_MESSAGE_ERROR:
        case ActionType.DELETE_MESSAGE_ERROR:
            return {
                ...state,
                inProcess: false
            }
        case ActionType.DELETE_MESSAGE_SUCCESS:
            // const filteredMessages = state.data.messages.filter(item => action.payload.id.every(id => id !== item.id))
            const filteredMessages = action.payload.allMessages ? action.payload.id.length ? state.data.messages.filter(item => action.payload.id.includes(item.id)) : [] : state.data.messages.filter(item => action.payload.id.every(id => id !== item.id))
            return {
                ...state,
                inProcess: false,
                data: {
                    ...state.data,
                    messages: filteredMessages
                }
            }
        default:
            return state;
    }
}

